module.exports = __webpack_public_path__ + "img/cat-mobile.291bacfb.png";